const rxValuesByOption = {
  "SPH (Sphere)": {
    defaultValue: "0.00",
    positiveValues: [
      "0.25",
      "0.50",
      "0.75",
      "1.00",
      "1.25",
      "1.50",
      "1.75",
      "2.00",
      "2.25",
      "2.50",
      "2.75",
      "3.00",
      "3.25",
      "3.50",
      "3.75",
      "4.00",
      "4.25",
      "4.50",
      "4.75",
      "5.00",
      "5.25",
      "5.50",
      "5.75",
      "6.00",
      "6.25",
      "6.50",
      "6.75",
      "7.00",
      "7.25",
      "7.50",
      "7.75",
      "8.00",
    ],
    negativeValues: [
      "-0.25",
      "-0.50",
      "-0.75",
      "-1.00",
      "-1.25",
      "-1.50",
      "-1.75",
      "-2.00",
      "-2.25",
      "-2.50",
      "-2.75",
      "-3.00",
      "-3.25",
      "-3.50",
      "-3.75",
      "-4.00",
      "-4.25",
      "-4.50",
      "-4.75",
      "-5.00",
      "-5.25",
      "-5.50",
      "-5.75",
      "-6.00",
      "-6.25",
      "-6.50",
      "-6.75",
      "-7.00",
      "-7.25",
      "-7.50",
      "-7.75",
      "-8.00",
    ],
  },
  "CYL (Cylinder)": {
    defaultValue: "0.00",
    positiveValues: [
      "0.25",
      "0.50",
      "0.75",
      "1.00",
      "1.25",
      "1.50",
      "1.75",
      "2.00",
      "2.25",
      "2.50",
      "2.75",
      "3.00",
      "3.25",
      "3.50",
      "3.75",
      "4.00",
      "4.25",
      "4.50",
      "4.75",
      "5.00",
      "5.25",
      "5.50",
      "5.75",
      "6.00",
      "6.25",
      "6.50",
      "6.75",
      "7.00",
      "7.25",
      "7.50",
      "7.75",
      "8.00",
    ],
    negativeValues: [
      "-0.25",
      "-0.50",
      "-0.75",
      "-1.00",
      "-1.25",
      "-1.50",
      "-1.75",
      "-2.00",
      "-2.25",
      "-2.50",
      "-2.75",
      "-3.00",
      "-3.25",
      "-3.50",
      "-3.75",
      "-4.00",
      "-4.25",
      "-4.50",
      "-4.75",
      "-5.00",
      "-5.25",
      "-5.50",
      "-5.75",
      "-6.00",
      "-6.25",
      "-6.50",
      "-6.75",
      "-7.00",
      "-7.25",
      "-7.50",
      "-7.75",
      "-8.00",
    ],
  },
  Axis: {
    defaultValue: "000",
    positiveValues: [
      "091",
      "092",
      "093",
      "094",
      "095",
      "096",
      "097",
      "098",
      "099",
      "100",
      "101",
      "102",
      "103",
      "104",
      "105",
      "106",
      "107",
      "108",
      "109",
      "110",
      "111",
      "112",
      "113",
      "114",
      "115",
      "116",
      "117",
      "118",
      "119",
      "120",
      "121",
      "122",
      "123",
      "124",
      "125",
      "126",
      "127",
      "128",
      "129",
      "130",
      "131",
      "132",
      "133",
      "134",
      "135",
      "136",
      "137",
      "138",
      "139",
      "140",
      "141",
      "142",
      "143",
      "144",
      "145",
      "146",
      "147",
      "148",
      "149",
      "150",
      "151",
      "152",
      "153",
      "154",
      "155",
      "156",
      "157",
      "158",
      "159",
      "160",
      "161",
      "162",
      "163",
      "164",
      "165",
      "166",
      "167",
      "168",
      "169",
      "170",
      "171",
      "172",
      "173",
      "174",
      "175",
      "176",
      "177",
      "178",
      "179",
      "180",
    ],
    negativeValues: [
      "001",
      "002",
      "003",
      "004",
      "005",
      "006",
      "007",
      "008",
      "009",
      "010",
      "011",
      "012",
      "013",
      "014",
      "015",
      "016",
      "017",
      "018",
      "019",
      "020",
      "021",
      "022",
      "023",
      "024",
      "025",
      "026",
      "027",
      "028",
      "029",
      "030",
      "031",
      "032",
      "033",
      "034",
      "035",
      "036",
      "037",
      "038",
      "039",
      "040",
      "041",
      "042",
      "043",
      "044",
      "045",
      "046",
      "047",
      "048",
      "049",
      "050",
      "051",
      "052",
      "053",
      "054",
      "055",
      "056",
      "057",
      "058",
      "059",
      "060",
      "061",
      "062",
      "063",
      "064",
      "065",
      "066",
      "067",
      "068",
      "069",
      "070",
      "071",
      "072",
      "073",
      "074",
      "075",
      "076",
      "077",
      "078",
      "079",
      "080",
      "081",
      "082",
      "083",
      "084",
      "085",
      "086",
      "087",
      "088",
      "089",
      "090",
    ],
  },
  "Pupil Distance RL": {
    defaultValue: "None",
    positiveValues: [
      "47",
      "49",
      "51",
      "53",
      "55",
      "57",
      "59",
      "61",
      "63",
      "65",
      "67",
      "69",
      "71",
      "73",
      "75",
      "77",
      "79",
    ],
    negativeValues: [
      "46",
      "48",
      "50",
      "52",
      "54",
      "56",
      "58",
      "60",
      "62",
      "64",
      "66",
      "68",
      "70",
      "72",
      "74",
      "76",
      "78",
      "80",
    ],
  },
  "Pupil Distance": {
    defaultValue: "None",
    positiveValues: [
      "23.5",
      "24.5",
      "25.5",
      "26.5",
      "27.5",
      "28.5",
      "29.5",
      "30.5",
      "31.5",
      "32.5",
      "33.5",
      "34.5",
      "35.5",
      "36.5",
      "37.5",
      "38.5",
      "39.5",
    ],
    negativeValues: [
      "23.0",
      "24.0",
      "25.0",
      "26.0",
      "27.0",
      "28.0",
      "29.0",
      "30.0",
      "31.0",
      "32.0",
      "33.0",
      "34.0",
      "35.0",
      "36.0",
      "37.0",
      "38.0",
      "39.0",
      "40.0",
    ],
  },
  Add: {
    defaultValue: "N/A",
    positiveValues: [
      "+0.50",
      "+1.00",
      "+1.50",
      "+2.00",
      "+2.50",
      "+3.00",
      "+3.50",
      "+4.00",
    ],
    negativeValues: [
      "+0.25",
      "+0.75",
      "+1.25",
      "+1.75",
      "+2.25",
      "+2.75",
      "+3.25",
      "+3.75",
    ],
  },
  Prism: {
    defaultValue: "0.00",
    positiveValues: [
      "0.10",
      "0.20",
      "0.30",
      "0.40",
      "0.50",
      "0.60",
      "0.70",
      "0.80",
      "0.90",
      "1.00",
      "1.10",
      "1.20",
      "1.30",
      "1.40",
      "1.50",
      "1.60",
      "1.70",
      "1.80",
      "1.90",
      "2.00",
    ],
    negativeValues: [
      "0.05",
      "0.15",
      "0.25",
      "0.35",
      "0.45",
      "0.55",
      "0.65",
      "0.75",
      "0.85",
      "0.95",
      "1.05",
      "1.15",
      "1.25",
      "1.35",
      "1.45",
      "1.55",
      "1.65",
      "1.75",
      "1.85",
      "1.95",
    ],
  },
};

const HEADERS = {
  Accept: "*/*",
  "Content-Type": "application/json;",
  "X-Requested-With": "XMLHttpRequest",
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "0",
};

const SELECTORS = {
  PARENT_WRAPPER: ".js-values-container-wrapper",
  DRAWER_HEADING: ".js-drawer-heading",
  DRAWER_OPTIONS_VALUES_HEADING: ".js-options-values-heading",
  PARENT: ".js-values-container",
  DEFAULT_VALUE_BTN: ".js-default-value-btn",
  DYNAMIC_VALUES: ".js-dynamic-values-container",
  LINE_ITEM_QTY_BTN: ".go-cart-item__quantity-button",
  LINE_ITEM_QTY: ".js-go-cart-quantity",
  LINE_ITEM_QTY_MINUS_BTN: ".js-go-cart-quantity-minus",
  LINE_ITEM_QTY_PLUS_BTN: ".js-go-cart-quantity-plus",
  LINE_ITEM_REMOVE_BTN: ".js-go-cart-remove-from-cart",
  LINE_ITEM: ".go-cart-item__single",
};

document.addEventListener("alpine:init", () => {
  async function addItems(items = []) {
    const body = JSON.stringify({
      items: items.map((i) => ({
        ...i,
        properties: { ...i.properties, _p: "default empty property" },
      })),
      sections: "cart-items,cart-footer,cart-item-count",
      sections_url: window.location.pathname,
    });

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: HEADERS,
      body: body,
    });

    return await res.json();
  }
  Alpine.data("rxForm", ({ sectionId }) => ({
    SHOP_DOMAIN: "epokhe.myshopify.com",
    ANALYZE_PRESCRIPTION: "https://script.xprizm.com/api/analyze-prescription",
    PRESCRIPTION_URL: "https://api.xprizm.com/api/prescription",
    PRESCRIPTION_URL_VALUES: "https://api.xprizm.com/api/prescription/values",
    AUTH_HEADERS: {
      Authorization: "Bearer dev_test_token_12345",
      "X-Shopify-Hmac-SHA256": "fea1978ed249b3a5c2d3344ba9d06954",
    },

    sectionId,
    URI: "https://api-master.australia.wnotglobal.com",
    step: "INITIAL", // "INITIAL", "UPLOAD", "MANUAL"
    isUploading: false,
    uploaded: false,
    file: null,
    filePath: null,
    data: null,
    cart: null,
    isOpenDrawer: false,
    isShowPlusMinusHeading: true,
    manualFormFieldKey: "",
    drawerOptionTitle: "",
    drawerEye: "",
    drawerValues: {
      defaultValue: "",
      positiveValues: [],
      negativeValues: [],
    },
    isOpenPD: false,
    isOpenPrism: false,
    rxValuesByOption: {
      ...rxValuesByOption,
    },
    manualFormField: {
      SPH: {
        R: "0.00",
        L: "0.00",
      },
      CYL: {
        R: "0.00",
        L: "0.00",
      },
      AXIS: {
        R: "000",
        L: "000",
      },
      PUPIL_RL: {
        RL: "None",
      },
      PUPIL: {
        R: "None",
        L: "None",
      },
      ADD: {
        R: "N/A",
        L: "N/A",
      },
      PRISM: {
        R: {
          vertical: {
            direction: "U",
            value: "0.00",
          },
          horizontal: {
            direction: "I",
            value: "0.00",
          },
        },
        L: {
          vertical: {
            direction: "U",
            value: "0.00",
          },
          horizontal: {
            direction: "I",
            value: "0.00",
          },
        },
      },
      COMMENT: "",
    },
    prescriptionData: null,

    isWaitAnalyze: false,
    rxPreviewUrl: null,
    requiredFields: [],
    waitingAnalyzeIndex: 0,
    waitingAnalyzeText: "",
    activeTypeOption: null,
    isShowScrollDownBtn: true,
    uniqueId: null,

    async init() {
      this.frame = this.activeTags.frame;
      this.$watch("activeTags", (value, oldValue) => {
        this.frame = value.frame;
      });
      this.$watch("drawerValues", (value, oldValue) => {
        this.$nextTick(() => {
          this.calcScrollContainerHeight();
        });
      });
      window.addEventListener(
        "message",
        (event) => {
          if (!event?.data?.pd) return;
          this.manualFormField.PUPIL_RL.RL = `${event?.data?.pd}`;
          if (this.isOpenPD) {
            this.togglePDOption();
          }
          this.closeIframePD();
        },
        false
      );

      this.initFormFieldWatchers();
    },
    initFormFieldWatchers() {
      this.$watch("manualFormField.CYL.R", () => {
        if (
          this.manualFormField.CYL.R != "0" &&
          this.manualFormField.CYL.R != "0.0" &&
          this.manualFormField.CYL.R != "0.00"
        ) {
          if (!this.requiredFields.includes("AXIS.R")) {
            this.requiredFields.push("AXIS.R");
          }
        } else {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "AXIS.R"
          );
        }
      });

      this.$watch("manualFormField.CYL.L", () => {
        if (
          this.manualFormField.CYL.L != "0" &&
          this.manualFormField.CYL.L != "0.0" &&
          this.manualFormField.CYL.L != "0.00"
        ) {
          if (!this.requiredFields.includes("AXIS.L")) {
            this.requiredFields.push("AXIS.L");
          }
        } else {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "AXIS.L"
          );
        }
      });

      this.$watch("manualFormField.AXIS.R", () => {
        if (this.manualFormField.AXIS.R != "000") {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "AXIS.R"
          );
        }
      });

      this.$watch("manualFormField.AXIS.L", () => {
        if (this.manualFormField.AXIS.L != "000") {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "AXIS.L"
          );
        }
      });

      this.$watch("manualFormField.PUPIL_RL.RL", () => {
        if (this.manualFormField.PUPIL_RL.RL == "None" && !this.isOpenPD) {
          if (!this.requiredFields.includes("PUPIL_RL.RL")) {
            this.requiredFields.push("PUPIL_RL.RL");
          }
        } else {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "PUPIL_RL.RL"
          );
        }
      });

      this.$watch("manualFormField.PUPIL.R", () => {
        if (this.manualFormField.PUPIL.R == "None" && this.isOpenPD) {
          if (!this.requiredFields.includes("PUPIL.R")) {
            this.requiredFields.push("PUPIL.R");
          }
        } else {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "PUPIL.R"
          );
        }
      });

      this.$watch("manualFormField.PUPIL.L", () => {
        if (this.manualFormField.PUPIL.L == "None" && this.isOpenPD) {
          if (!this.requiredFields.includes("PUPIL.L")) {
            this.requiredFields.push("PUPIL.L");
          }
        } else {
          this.requiredFields = this.requiredFields.filter(
            (el) => el != "PUPIL.L"
          );
        }
      });
    },
    closePopup() {
      this.handleClickReturn();
      this.togglePrescriptionPopup();
    },
    titleCase(str) {
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    },
    openIframePD() {
      const $documentEl = document.documentElement;

      $documentEl.insertAdjacentHTML(
        "beforeend",
        `<div
          id="pd-iframe"
          class="fixed z-full inset-0 w-full h-full flex items-center justify-center backdrop-blur-6px bg-white/90"
          @click.self="document.querySelector('#pd-iframe').remove();"
        >
          <div class="relative w-[75vw] h-[75vh] flex overflow-hidden rounded-[32px]">
            <iframe
            class="!w-full !h-full"
              src="https://pd.eazyvisi.com/?primaryColor=FFF&textColor=000&lineColor=FFF&borderRadius=3px"
              width="100%"
              height="100%"
              allow="camera"
            ></iframe>
          </div>
        </div>`
      );
    },
    closeIframePD() {
      document.querySelector("#pd-iframe").remove();
    },
    setManualField({ manualFormFieldKey, value }) {
      const [field, eye] = manualFormFieldKey.split(".");
      this.manualFormField[field][eye] = value;
    },
    setManualFieldPrism({ manualFormFieldKey, value }) {
      const [field, eye, origin] = manualFormFieldKey.split(".");
      this.manualFormField[field][eye][origin].value = value;
    },
    setDrawerInstance({
      key,
      drawerOptionTitle,
      drawerEye,
      isShowPlusMinusHeading = true,
      manualFormFieldKey,
    }) {
      this.drawerOptionTitle = drawerOptionTitle;
      this.drawerEye = drawerEye;
      this.isShowPlusMinusHeading = isShowPlusMinusHeading;
      this.drawerValues = this.rxValuesByOption[key];
      this.manualFormFieldKey = manualFormFieldKey;
      this.toggleDrawer();
    },
    handleChangeManualFormField({ manualFormFieldKey, value }) {
      const [fieldKey] = manualFormFieldKey.split(".");
      if (fieldKey === "PRISM") {
        this.setManualFieldPrism({
          manualFormFieldKey,
          value,
        });
        this.toggleDrawer();
        return;
      }
      this.setManualField({
        manualFormFieldKey,
        value,
      });
      this.toggleDrawer();
    },
    setStep(step) {
      this.step = step;
    },
    async handleInput(e) {
      const file = e.target.files[0];
      this.file = file;
      // this.rxPreviewUrl = URL.createObjectURL(file);
      // this.prepareData();
      try {
        // const URL = `${this.URI}/api/store/prescriptions/file`;
        // const formData = new FormData();
        // formData.append("file", file);
        // const res = await fetch(URL, { method: "POST", body: formData });
        // const data = await res.json();
        // this.prescriptionData = data;
        this.filePath = URL.createObjectURL(file);
        this.uploaded = true;
      } catch (e) {
        this.isUploading = false;
        this.file = null;
        this.uploaded = false;
        console.log(e);
      } finally {
        e.target.value = "";
      }
    },
    removeFile() {
      document.dispatchEvent(
        new CustomEvent("upload:removed", {
          detail: this.data,
        })
      );
      this.file = null;
      this.filePath = null;
      this.data = null;
      this.rxPreviewUrl = null;
    },
    handleClickReturn(step = "INITIAL") {
      this.setStep(step);
      this.file = null;
      this.resetForm();
    },
    resetForm() {
      this.manualFormField.SPH.R = "0.00";
      this.manualFormField.SPH.L = "0.00";
      this.manualFormField.CYL.R = "0.00";
      this.manualFormField.CYL.L = "0.00";
      this.manualFormField.AXIS.R = "000";
      this.manualFormField.AXIS.L = "000";
      this.manualFormField.PUPIL_RL.RL = "None";
      this.manualFormField.PUPIL.R = "None";
      this.manualFormField.PUPIL.L = "None";
      this.manualFormField.ADD.R = "N/A";
      this.manualFormField.ADD.L = "N/A";
      this.manualFormField.PRISM.R.vertical.direction = "U";
      this.manualFormField.PRISM.R.vertical.value = "0.00";
      this.manualFormField.PRISM.R.horizontal.direction = "I";
      this.manualFormField.PRISM.R.horizontal.value = "0.00";
      this.manualFormField.PRISM.L.vertical.direction = "U";
      this.manualFormField.PRISM.L.vertical.value = "0.00";
      this.manualFormField.PRISM.L.horizontal.direction = "I";
      this.manualFormField.PRISM.L.horizontal.value = "0.00";
      this.manualFormField.COMMENT = "";
      this.isOpenPD = false;
      this.isOpenPrism = false;
    },
    async submitFileEntering() {
      const { left, right } = this.createPDValue();

      const prescriptionValues = await this.postPrescriptionFile({
        url: this.PRESCRIPTION_URL,
      });
      this.uniqueId = prescriptionValues.analysis.uniqueId || null;

      const frameName = this.frameName.toUpperCase();
      const sku = this.selectedVariant.sku;
      const frameDescription = ["EPOKHE", frameName, sku]
        .filter((val) => Boolean(val))
        .join(" ")
        .trim();
      const healthFundItemNumbers = this.healthFundItemNumbers();
      const lensStyle = this.activeMaterialGroup;
      const lensColor = this.rxLensSelectedVariant.option1
        .split("/")
        .pop()
        .trim();
      const lensType = this.activeMaterialGroup;
      const frameColor = this.frameColor;
      const properties = {
        _prescription_type: "file",
        "Frame Description": frameDescription,
        "_frame-image": this.product.media.filter(
          (item) => item.media_type === "image"
        )[0]
          ? this.product.media.filter((item) => item.media_type === "image")[0]
              .src
          : "",
        "Provider number": "592177MH",
        "Health Fund Item Numbers": healthFundItemNumbers,
        // Prescription: this.prescriptionData.id,
        _frame_variant_id: this.selectedVariant.id,

        "Prescription RX UID": prescriptionValues.rxUID,
        rxOrder: "true",
        "Frame MFC": frameDescription,
        "Frame SKU": this.selectedVariant.sku || this.selectedVariant.id,
        "Lens SKU": this.rxLensSelectedVariant.sku,
        "Lens Style": lensStyle,
      };

      if (!this.isOpenPD) {
        properties["Pupillary Distance"] = `${
          parseFloat(left) + parseFloat(right)
        }mm`;
      } else {
        properties["Pupillary Distance Left"] = `${parseFloat(left)}mm`;
        properties["Pupillary Distance Right"] = `${parseFloat(right)}mm`;
      }

      const rxLensProduct = {
        id: this.rxLensSelectedVariant.id,
        quantity: 1,
        properties,
      };
      const frameProduct = {
        id: this.selectedVariant.id,
        quantity: 1,
      };
      const hash = new Date().getTime();
      const _bundleHash = `bundle-hash-${hash}-${this.rxLensSelectedVariant.id}-${this.selectedVariant.id}`;

      rxLensProduct["properties"] = {
        ...rxLensProduct.properties,
        _bundleHash,
      };
      frameProduct["properties"] = { _bundleHash };

      if (frameColor) {
        frameProduct.properties["Frame Color"] = frameColor;
        rxLensProduct.properties["Frame Color"] = frameColor;
      }
      if (lensColor) {
        rxLensProduct.properties["Lens Color"] = lensColor;
      }
      if (lensType) {
        rxLensProduct.properties["Lens Material"] = lensType;
      }

      if (this.uniqueId) {
        rxLensProduct.properties["uniqueId"] = this.uniqueId;
      }

      const data = await addItems([rxLensProduct, frameProduct]);
      this.closePopup();
      document.body.dispatchEvent(
        new CustomEvent("baseline:cart:afteradditem", {
          bubbles: true,
          detail: { response: data },
        })
      );
      this.isUploading = false;
    },
    async submitManualEntering() {
      const { left, right } = this.createPDValue();
      const payload = {
        eye_r: {
          sphere: this.manualFormField.SPH.R,
          cylinder: {
            axis: this.manualFormField.AXIS.R,
            value: this.manualFormField.CYL.R,
          },
          PD: left,
          add: {
            power:
              this.manualFormField.ADD.R === "N/A"
                ? "0.00"
                : this.manualFormField.ADD.R,
          },
        },
        eye_l: {
          sphere: this.manualFormField.SPH.L,
          cylinder: {
            axis: this.manualFormField.AXIS.L,
            value: this.manualFormField.CYL.L,
          },
          PD: right,
          add: {
            power:
              this.manualFormField.ADD.L === "N/A"
                ? "0.00"
                : this.manualFormField.ADD.L,
          },
        },
      };
      const prescriptionPayload = this.getPrescriptionPayload({ left, right });
      if (this.isOpenPrism) {
        payload.eye_r["prism"] = {
          axis: this.manualFormField.AXIS.R,
          direction: this.manualFormField.PRISM.R.vertical.direction,
          value: this.manualFormField.PRISM.R.vertical.value,
        };
        payload.eye_r["prism2"] = {
          axis: this.manualFormField.AXIS.R,
          direction: this.manualFormField.PRISM.R.horizontal.direction,
          value: this.manualFormField.PRISM.R.horizontal.value,
        };
        payload.eye_l["prism"] = {
          axis: this.manualFormField.AXIS.L,
          direction: this.manualFormField.PRISM.L.vertical.direction,
          value: this.manualFormField.PRISM.L.vertical.value,
        };
        payload.eye_l["prism2"] = {
          axis: this.manualFormField.AXIS.L,
          direction: this.manualFormField.PRISM.L.horizontal.direction,
          value: this.manualFormField.PRISM.L.horizontal.value,
        };
      }
      try {
        // const URL = `${this.URI}/api/store/prescriptions/json`;
        this.isUploading = true;
        // const res = await fetch(URL, {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify(payload),
        // });
        // const data = await res.json();
        const prescriptionValues = await this.postPrescriptionValues({
          url: this.PRESCRIPTION_URL_VALUES,
          data: prescriptionPayload,
        });
        const frameName = this.frameName.toUpperCase();
        const sku = this.selectedVariant.sku;
        const frameDescription = ["EPOKHE", frameName, sku]
          .filter((val) => Boolean(val))
          .join(" ")
          .trim();

        const healthFundItemNumbers = this.healthFundItemNumbers();
        const lensStyle = this.activeMaterialGroup;
        const lensColor = this.rxLensSelectedVariant.option1
          .split("/")[1]
          ?.trim();
        const lensType = this.activeMaterialGroup;
        const frameColor = this.frameColor;

        const properties = {
          _prescription_type: "manual",
          "Frame Description": frameDescription,
          "_frame-image": this.product.media.filter(
            (item) => item.media_type === "image"
          )[0]
            ? this.product.media.filter(
                (item) => item.media_type === "image"
              )[0].src
            : "",
          "Provider number": "592177MH",
          "Health Fund Item Numbers": healthFundItemNumbers,
          // Prescription: data.id,
          _frame_variant_id: this.selectedVariant.id,

          "Prescription RX UID": prescriptionValues.rxUID,
          rxOrder: "true",
          "Frame MFC": frameDescription,
          "Frame SKU": this.selectedVariant.sku || this.selectedVariant.id,
          "Lens SKU": this.rxLensSelectedVariant.sku,
          "Lens Style": lensStyle,
        };

        if (!this.isOpenPD) {
          properties["Pupillary Distance"] = `${
            parseFloat(left) + parseFloat(right)
          }mm`;
        } else {
          properties["Pupillary Distance Left"] = `${parseFloat(left)}mm`;
          properties["Pupillary Distance Right"] = `${parseFloat(right)}mm`;
        }

        if (this.manualFormField.COMMENT) {
          properties["Buyer's notes"] = this.manualFormField.COMMENT;
        }

        const rxLensProduct = {
          id: this.rxLensSelectedVariant.id,
          quantity: 1,
          properties,
        };
        const frameProduct = {
          id: this.selectedVariant.id,
          quantity: 1,
        };
        const hash = new Date().getTime();
        const _bundleHash = `bundle-hash-${hash}-${this.rxLensSelectedVariant.id}-${this.selectedVariant.id}`;

        rxLensProduct["properties"] = {
          ...rxLensProduct.properties,
          _bundleHash,
        };
        frameProduct["properties"] = { _bundleHash };

        if (frameColor) {
          frameProduct.properties["Frame Color"] = frameColor;
          rxLensProduct.properties["Frame Color"] = frameColor;
        }
        if (lensColor) {
          rxLensProduct.properties["Lens Color"] = lensColor;
        }
        if (lensType) {
          rxLensProduct.properties["Lens Material"] = lensType;
        }

        const _data = await addItems([rxLensProduct, frameProduct]);
        this.closePopup();
        document.body.dispatchEvent(
          new CustomEvent("baseline:cart:afteradditem", {
            bubbles: true,
            detail: { response: _data },
          })
        );
        this.isUploading = false;
      } catch (e) {
        this.isUploading = false;
        this.uploaded = false;
        console.log(e);
      }
    },
    async goToCheckout() {
      try {
        const rxLensProduct = {
          id: this.rxLensSelectedVariant.id,
          quantity: 1,
          properties: {
            _frame_variant_id: this.selectedVariant.id,
          },
        };
        const frameProduct = {
          id: this.selectedVariant.id,
          quantity: 1,
          properties: {},
        };
        const frameName = this.frameName.toUpperCase();
        const sku = this.selectedVariant.sku;
        const frameDescription = ["EPOKHE", frameName, sku]
          .filter((val) => Boolean(val))
          .join(" ")
          .trim();

        const hash = new Date().getTime();
        const _bundleHash = `bundle-hash-${hash}-${this.rxLensSelectedVariant.id}-${this.selectedVariant.id}`;

        const healthFundItemNumbers = this.healthFundItemNumbers();
        rxLensProduct["properties"] = {
          "Frame Description": frameDescription,
          "_frame-image": this.product.media.filter(
            (item) => item.media_type === "image"
          )[0]
            ? this.product.media.filter(
                (item) => item.media_type === "image"
              )[0].src
            : "",
          "Provider number": "592177MH",
          "Health Fund Item Numbers": healthFundItemNumbers,
          _bundleHash,
          _frame_variant_id: this.selectedVariant.id,
          rxOrder: "true",
        };
        frameProduct["properties"] = { _bundleHash };

        const data = await addItems([rxLensProduct, frameProduct]);
        this.closePopup();
        document.body.dispatchEvent(
          new CustomEvent("baseline:cart:afteradditem", {
            bubbles: true,
            detail: { response: data },
          })
        );
        this.isUploading = false;
      } catch (e) {
        this.isUploading = false;
        this.uploaded = false;
        console.log(e);
      }
    },
    addToCart(properties = null) {
      const form = document
        .querySelector(`[data-section-id="${this.sectionId}"]`)
        .querySelector("form");
      const formData = new FormData(form);
      formData.append("sections_url", window.location.pathname);
      if (properties) {
        for (const [key, value] of Object.entries(properties)) {
          formData.append(`properties[${key}]`, value);
        }
      }
      this.isUploading = true;
      this.isUploading = false;
    },
    clickOutside() {
      this.closePrescriptionPopup();
      this.handleClickReturn("INITIAL");
    },
    createPDValue() {
      let value = 32.0;
      if (!this.isOpenPD) {
        value =
          this.manualFormField.PUPIL_RL.RL === "None"
            ? 32.0
            : parseFloat(this.manualFormField.PUPIL_RL.RL) / 2;

        return {
          right: value.toFixed(1),
          left: value.toFixed(1),
        };
      }
      return {
        right:
          this.manualFormField.PUPIL.R === "None"
            ? value.toFixed(1)
            : this.manualFormField.PUPIL.R,
        left:
          this.manualFormField.PUPIL.L === "None"
            ? value.toFixed(1)
            : this.manualFormField.PUPIL.L,
      };
    },
    togglePDOption() {
      this.isOpenPD = !this.isOpenPD;
      this.manualFormField.PUPIL.L = "None";
      this.manualFormField.PUPIL.R = "None";
    },
    togglePrismBlock() {
      this.isOpenPrism = !this.isOpenPrism;
    },
    toggleDrawer() {
      this.isOpenDrawer = !this.isOpenDrawer;
      if (document.querySelector(SELECTORS.PARENT_WRAPPER)) {
        document.querySelector(SELECTORS.PARENT_WRAPPER).scrollTop = 0;
      }
    },
    calcScrollContainerHeight() {
      const $parent = document.querySelector(SELECTORS.PARENT);
      const drawerHeadingHeight = this.getHeightBySelector(
        SELECTORS.DRAWER_HEADING
      );
      const drawerOptionsValuesHeadingHeight = this.getHeightBySelector(
        SELECTORS.DRAWER_OPTIONS_VALUES_HEADING
      );
      const dynamicValuesHeight = this.getHeightBySelector(
        SELECTORS.DYNAMIC_VALUES
      );
      const defaultValueBtnHeight = this.getHeightBySelector(
        SELECTORS.DEFAULT_VALUE_BTN
      );

      $parent.style.height = `${
        dynamicValuesHeight +
        drawerHeadingHeight +
        drawerOptionsValuesHeadingHeight +
        defaultValueBtnHeight
      }px`;
    },
    getHeightBySelector(selector) {
      const el = document.querySelector(selector);
      if (!el) {
        return 0;
      }
      return el.getBoundingClientRect().height;
    },
    healthFundItemNumbers() {
      const lensVariantTitleLowerCase =
        this.rxLensSelectedVariant.title.toLowerCase();
      const eyewear = this.rxLensProduct.tags.find((tag) =>
        tag.includes("eyewear_")
      );
      const values = [110];

      if (
        lensVariantTitleLowerCase.includes("colored") ||
        lensVariantTitleLowerCase.includes("polarized")
      ) {
        values.push(632);
      } else if (lensVariantTitleLowerCase.includes("transitions®")) {
        values.push(644);
      }

      switch (eyewear) {
        case "eyewear_Readers":
          values.push(212, 612);
          break;
        case "eyewear_Distance":
          values.push(512, 612);
          break;
        default:
          values.push(212, 612);
      }

      return values.join(", ");
    },

    async postPrescriptionFile({ url }) {
      const line_item_id = "prescription-" + Date.now();
      const shop_domain = this.SHOP_DOMAIN;
      const order_id = this.SHOP_DOMAIN;

      const formData = new FormData();
      formData.append("shop_domain", shop_domain);
      formData.append("order_id", order_id);
      formData.append("line_item_id", line_item_id);

      if (this.file) {
        formData.append("prescription", this.file);
      }

      try {
        this.isUploading = true;
        const response = await fetch(url, {
          method: "POST",
          headers: this.getAuthHeaders(null),
          body: formData,
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.message || "Upload failed");

        return result;
      } catch (error) {
        console.error("Error uploading prescription file:", error);
        throw error;
      } finally {
        this.isUploading = false;
      }
    },
    async postPrescriptionValues({ url, data }) {
      const payload = {
        line_item_id: "prescription-" + Date.now(),
        shop_domain: this.SHOP_DOMAIN,
        order_id: this.SHOP_DOMAIN,
        ...(data && { ...data }),
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: this.getAuthHeaders("application/json"),
          body: JSON.stringify(payload),
        });

        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.message || "Submission failed");
        }

        return result;
      } catch (error) {
        console.error("Error submitting prescription values:", error);
        throw error;
      }
    },
    async prepareData() {
      const analyzedData = await this.analyzePrescription();
      if (!analyzedData) {
        this.setStep("MANUAL");
        return;
      }

      const { prescriptionData } = analyzedData;

      console.log({ prescriptionData });

      if (prescriptionData.isMonocularPd) {
        this.manualFormField.PUPIL.R = prescriptionData.pdRight || "None";
        this.manualFormField.PUPIL.L = prescriptionData.pdLeft || "None";
      } else {
        this.manualFormField.PUPIL_RL.RL =
          prescriptionData.pupillaryDistance || "None";
      }

      const map = [
        { field: "SPH", keys: ["sphRight", "sphLeft"], eyes: ["R", "L"] },
        { field: "CYL", keys: ["cylRight", "cylLeft"], eyes: ["R", "L"] },
        { field: "AXIS", keys: ["axisRight", "axisLeft"], eyes: ["R", "L"] },
        { field: "ADD", keys: ["addRight", "addLeft"], eyes: ["R", "L"] },
      ];

      for (const { field, keys, eyes } of map) {
        keys.forEach((key, i) => {
          this.setManualFormFieldAfterAnalyze({
            field,
            eye: eyes[i],
            value: prescriptionData[key],
          });
        });
      }

      this.isOpenPD = prescriptionData.isMonocularPd;
      this.setStep("MANUAL");
    },
    async analyzePrescription() {
      const url = this.ANALYZE_PRESCRIPTION;
      let intervalId;

      this.isWaitAnalyze = true;
      this.isUploading = true;
      this.waitingAnalyzeIndex = 0;
      this.waitingAnalyzeText = WAITING_TEXTS[this.waitingAnalyzeIndex];

      intervalId = setInterval(() => {
        const newIndex = this.waitingAnalyzeIndex + 1;
        if (newIndex < WAITING_TEXTS.length) {
          this.waitingAnalyzeIndex = newIndex;
          this.waitingAnalyzeText = WAITING_TEXTS[newIndex];
        }
      }, 3000);

      const minWaitPromise = new Promise((resolve) =>
        setTimeout(resolve, 6000)
      );

      try {
        const formData = new FormData();
        formData.append("prescription", this.file);

        const response = await fetch(url, {
          method: "POST",
          headers: { ...this.getAuthHeaders() },
          body: formData,
        });

        let data = await response.json();
        if (data && data.success) {
          this.uniqueId = data.uniqueId;
          const [result] = await Promise.all([data, minWaitPromise]);
          return result;
        }
        console.error("Request failed (received false).");
        return null;
      } catch (error) {
        console.error(
          "An unexpected error occurred in analyzePrescription:",
          error
        );
        return null;
      } finally {
        clearInterval(intervalId);
        this.isWaitAnalyze = false;
        this.isUploading = false;
      }
    },
    setManualFormFieldAfterAnalyze({ field, eye, value }) {
      if (value != null && value !== "" && Number.isFinite(Number(value))) {
        this.manualFormField[field][eye] = value;
      }
    },
    getPrescriptionPayload({ left, right }) {
      let prescriptionPayload = {};

      prescriptionPayload = {
        data: {
          prescriptionData: {
            sphRight: this.manualFormField.SPH.R,
            cylRight: this.manualFormField.CYL.R,
            axisRight: this.manualFormField.AXIS.R,
            addRight:
              this.manualFormField.ADD.R === "N/A"
                ? "0.00"
                : this.manualFormField.ADD.R,

            sphLeft: this.manualFormField.SPH.L,
            cylLeft: this.manualFormField.CYL.L,
            axisLeft: this.manualFormField.AXIS.L,
            addLeft:
              this.manualFormField.ADD.L === "N/A"
                ? "0.00"
                : this.manualFormField.ADD.L,
          },
        },
      };

      if (this.isOpenPrism) {
        prescriptionPayload.data.prescriptionData["prismLeft"] = {
          value: this.manualFormField.PRISM.L.vertical.value,
          direction: this.manualFormField.PRISM.L.vertical.direction,
        };
        prescriptionPayload.data.prescriptionData["prismRight"] = {
          value: this.manualFormField.PRISM.R.vertical.value,
          direction: this.manualFormField.PRISM.R.vertical.direction,
        };

        prescriptionPayload.data.prescriptionData["prism2Left"] = {
          value: this.manualFormField.PRISM.L.horizontal.value,
          direction: this.manualFormField.PRISM.L.horizontal.direction,
        };
        prescriptionPayload.data.prescriptionData["prism2Right"] = {
          value: this.manualFormField.PRISM.R.horizontal.value,
          direction: this.manualFormField.PRISM.R.horizontal.direction,
        };
      }

      prescriptionPayload.data.prescriptionData["isMonocularPd"] =
        this.isOpenPD;

      if (this.isOpenPD) {
        prescriptionPayload.data.prescriptionData["pdLeft"] = `${parseFloat(
          left
        )}mm`;
        prescriptionPayload.data.prescriptionData["pdRight"] = `${parseFloat(
          right
        )}mm`;
      } else {
        prescriptionPayload.data.prescriptionData["pdValue"] = `${
          parseFloat(left) + parseFloat(right)
        }mm`;
      }

      return prescriptionPayload;
    },
    getAuthHeaders(contentType = "application/json") {
      const headers = new Headers();
      if (contentType) headers.append("Content-Type", contentType);
      for (const [key, value] of Object.entries(this.AUTH_HEADERS)) {
        headers.append(key, value);
      }
      return headers;
    },
    getLensOption(name) {
      return this.rxLensProduct.productOptions
        .find((opt) => opt.name === name)
        ?.values.find((val) =>
          this.rxLensSelectedVariant.options.includes(val)
        );
    },
    getFrameOption(name) {
      return this.product.productOptions
        .find((opt) => opt.name === name)
        ?.values.find((val) => this.selectedVariant.options.includes(val));
    },
    scrollToButton() {
      if (this.$refs.submitBtn) {
        this.$refs.submitBtn.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    },
  }));
});
